module.exports = __webpack_public_path__ + "static/media/mani.f0ac3dfc.jpg";